<template>
  <div class="case-content">
    <div class="title-content">
      <div class="big-title">{{ $t("route.case") }}</div>
      <div class="small-title">Customer Case</div>
    </div>
    <div class="case-img-content" >
      <div
      @click="getDetail(item.id)"
        :key="index"
        v-for="(item, index) in customerCaseList"
        class="case-img-item"
      >
        <div class="case-img">
          <img :src="item.mainPicture" alt="" />
        </div>
        <div class="case-text">{{ item.caseName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/axios/index.js";
export default {
  name: "mobile-case",
  props: {
    msg: String,
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 100,
        orders: { sequence: "desc" },
        param: {
          lang: "zh_CN",
        },
      },
      customerCaseList: [],
    };
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    this.customerCaseList = [];
    this.getCustomerCaseList();
  },
  mounted() {},
  methods: {
    // 获取客户案例列表
    getCustomerCaseList() {
      const url = `/frontCustomerCase/page`;
      http
        .post(url, this.params)
        .then((res) => {
          if (res.code === "00000") {
            this.customerCaseList = res.data.list;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 查看案例详情
    getDetail(id){
      this.$router.push({
        path: "/mobile/case/detail",
        query: {
          id,
        },
      });
    }
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
      this.customerCaseList = [];
      this.getCustomerCaseList();
    },
  },
};
</script>
<style lang="less" scoped>
.case-content {
  box-sizing: border-box;
  overflow: scroll;
  .title-content {
    padding-top: 9.4rem;
    padding-bottom: 7.4rem;
    text-align: center;
    .big-title {
      font-size: 4.2rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2b2b2b;
    }

    .small-title {
      font-size: 2.4rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #1ea5ff;
    }
  }
  .case-img-content {
    overflow: scroll;
    box-sizing: border-box;
    padding: 0 4rem 4rem 4rem;

    .case-img-item {
      width: 31.2rem;
      display: inline-flex;
      flex-direction: column;
      box-sizing: border-box;
      overflow: hidden;
      &:nth-child(2n) {
        margin-left: 4.6rem;
      }
      &:nth-child(1n + 1) {
        margin-top: 4.6rem;
      }
      &:nth-child(1) {
        margin-top: unset;
      }
      &:nth-child(2) {
        margin-top: unset;
      }
      .case-img {
        overflow: hidden;
        width: 30rem;
        height: 20rem;
        background: #ffffff;
        border-radius: 0.6rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .case-text {
        width: 100%;
        margin-top: 1.4rem;
        text-align: center;
        font-size: 2.4rem;
      }
    }
  }
}
</style>
